import { render, staticRenderFns } from "./SignPanelConfig.vue?vue&type=template&id=7d22af06&scoped=true"
import script from "./SignPanelConfig.vue?vue&type=script&lang=js"
export * from "./SignPanelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22af06",
  null
  
)

export default component.exports